const now = new Date();
export const TOMORROW = new Date(now.getTime() + 24 * 60 * 60 * 1000);
export const END_OF_YEAR = new Date(now.getFullYear(), 11, 31, 23, 59, 59, 999);
export const END_OF_NEXT_YEAR = new Date(
  now.getFullYear() + 1,
  11,
  31,
  23,
  59,
  59,
  999
);
export const FIRST_DAY_OF_NEXT_MONTH = new Date(
  now.getFullYear(),
  now.getMonth() + 1,
  1
);

export const December = new Date(now.getFullYear(), 11, 1).getTime();
export const today = now.getTime();

export const isTomorrow = (date?: string | null) => {
  if (!date) return false;
  const day = new Date(date).getTime();
  const tomorrow = TOMORROW;

  if (today > December) {
    return (
      day >= tomorrow.setHours(0, 0, 0, 0) && day < END_OF_NEXT_YEAR.getTime()
    );
  }
  return day >= tomorrow.setHours(0, 0, 0, 0) && day < END_OF_YEAR.getTime();
};
